// Die Adresse, unter der das Verzeichnis das angemeldete Konto führt.
//
// MSAL liefert den Entra-Anmeldenamen. Bei den meisten ist das die Mailadresse –
// aber nicht bei allen (`tanja.schultenoelle@` als Anmeldename,
// `tanja.schulte-noelle@` im Verzeichnis), und Adressen werden auch geändert.
// Der Server löst die Person deshalb über ihre Entra-Objekt-ID auf
// (api/_identity.js) und nennt uns im Kontostatus die Adresse, an der Gruppe,
// Abschlüsse und Zertifikate hängen. Ab dann arbeitet die App mit ihr.
//
// Gemerkt wird das pro Anmeldename im localStorage, damit die Adresse beim
// nächsten Start sofort (synchron) da ist. Der Merker ist keine
// Sicherheitsentscheidung: Der Server übersetzt den Anmeldenamen ohnehin selbst,
// hier geht es nur darum, dass die App die eigenen Daten in den Antworten findet.

const PREFIX = "sherloxaware_directory_email:";

const memory = new Map<string, string>();

function normalize(value: string | null | undefined): string {
  return (value ?? "").toLowerCase().trim();
}

/** Verzeichnis-Adresse zum Anmeldenamen; ohne Merker der Anmeldename selbst. */
export function directoryEmailFor(loginEmail: string | null | undefined): string {
  const login = normalize(loginEmail);
  if (!login) return "";
  const known = memory.get(login);
  if (known !== undefined) return known || login;
  let stored = "";
  try { stored = normalize(localStorage.getItem(PREFIX + login)); } catch { /* Storage gesperrt */ }
  memory.set(login, stored);
  return stored || login;
}

/**
 * Antwort des Servers übernehmen. Liefert `true`, wenn sich die Adresse dadurch
 * geändert hat UND dauerhaft gemerkt werden konnte – nur dann lohnt ein
 * Neuladen (ohne Storage würde es sonst bei jedem Start neu laden).
 */
export function rememberDirectoryEmail(loginEmail: string | null | undefined, directoryEmail: unknown): boolean {
  const login = normalize(loginEmail);
  const directory = typeof directoryEmail === "string" ? normalize(directoryEmail) : "";
  if (!login || !directory.includes("@")) return false;
  const next = directory === login ? "" : directory;
  const previous = directoryEmailFor(login);
  if ((next || login) === previous) return false;
  memory.set(login, next);
  try {
    if (next) localStorage.setItem(PREFIX + login, next);
    else localStorage.removeItem(PREFIX + login);
    return normalize(localStorage.getItem(PREFIX + login)) === next;
  } catch {
    return false;
  }
}
